// SSR reaches Nuxt's own listener, not nginx: no public host, no TLS. Port resolved like Nitro's
// node server — the image runs Nuxt on NITRO_PORT behind nginx on 3000 (.docker/mainsite/entrypoint.sh).
// `globalThis.process`: read at runtime, and absent in the browser, which never self-fetches.
const env = (
  globalThis as { process?: { env: Record<string, string | undefined> } }
).process?.env;
const internalOrigin = `http://localhost:${env?.NITRO_PORT || env?.PORT || "3000"}`;

export { internalOrigin };
